import { Component } from '@angular/core';
import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { ApiConstants } from 'src/app/constants/api-constants';

@Component({
  selector: 'app-custom-toastr',
  templateUrl: './custom-toastr.component.html', 
  styleUrls: ['./custom-toastr.component.css'],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        opacity: 1,
      })),
      transition('inactive <=> active', animate('500ms ease-out', keyframes([
        style({
          transform: 'translateX(340px)',
          offset: 0,
          opacity: 0,
        }),
        style({
          offset: .7,
          opacity: 1,
          transform: 'translateX(-20px)'
        }),
        style({
          offset: 1,
          transform: 'translateX(0)',
        })
      ]))),
      transition('active => removed', animate('500ms ease-in', keyframes([
        style({
          transform: 'translateX(-20px)',
          opacity: 1,
          offset: .2
        }),
        style({
          opacity: 0,
          transform: 'translateX(340px)',
          offset: 1
        })
      ])))
    ]),
  ],
  preserveWhitespaces: false,
})
export class CustomToastrComponent extends Toast {
  private _masterWebNotification: any;
  private _excludeType: string[] = ['Success', 'Warning', 'Error', 'Notification', "Partially Updated", "Initiated"];
  constructor(protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage, private _service: ServicecallService) {
    super(toastrService, toastPackage);
  }

  ngOnInit(): void {
    this._masterWebNotification = this._service.getConfiguration('webNotification') ? this._service.getConfiguration('webNotification') : {};
  }
  setToastrStyle(type: string, returnType: string) {
    if (this._masterWebNotification?.[type]) {
      let response = this._masterWebNotification[type]?.[returnType];
      returnType === 'imgUrl' ? response = response + ApiConstants.blobSasToken : '';
      return response;
    } else if (!this.isToasterDefault(type)) {
      return returnType === 'imgUrl' ? 'assets/images/info-toaster-icon.svg' : '#5B8EC4';
    }
    return '';
  }

  isToasterDefault(type: string) {
    return this._excludeType.includes(type);
  }

  setDefaultToasterImg(toasterType: string) {
    switch (toasterType) {
      case 'Success': return 'assets/images/toastr-success.svg';
      case 'Warning': return 'assets/images/toastr-warning.svg';
      case 'Error': return 'assets/images/toastr-error.svg';
      default: return 'assets/images/toastr-warning.svg';
    }
  }
  private _action(event: Event) {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    return false;
  }
  
}
